import { createEntityAdapter, createSlice, PayloadAction } from '@reduxjs/toolkit'
import { RootState } from '../rootReducer'

export type TPiPTab = 'home' | 'participants' | 'chat'

export interface IPiPState {
  currentTab: TPiPTab
}

export const initialPiPState: IPiPState = {
  currentTab: 'home',
}

const pipAdapter = createEntityAdapter()

export const pipSlice = createSlice({
  name: 'pip',
  initialState: pipAdapter.getInitialState(initialPiPState),
  reducers: {
    setCurrentTab: (state, action: PayloadAction<TPiPTab>) => {
      state.currentTab = action.payload
    },
    setPiPState: (state, action: PayloadAction<IPiPState>) => ({
      ...state,
      ...action.payload,
    }),
  },
})

export const { setCurrentTab, setPiPState } = pipSlice.actions

export const { selectAll: pipSelector } = pipAdapter.getSelectors(
  (state: RootState) => state[pipSlice.name],
)

export const selectPiPState = (state: RootState) => state.pip
export const selectPiPCurrentTab = (state: RootState) => state.pip.currentTab
